/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CoordinatesFromJSON, CoordinatesToJSON, CountryFromJSON, CountryToJSON, } from './';
export function PickupPayloadFromJSON(json) {
    return PickupPayloadFromJSONTyped(json, false);
}
export function PickupPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'country': CountryFromJSON(json['country']),
        'shopifyProductId': json['shopifyProductId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'currentPosition': !exists(json, 'currentPosition') ? undefined : CoordinatesFromJSON(json['currentPosition']),
    };
}
export function PickupPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country': CountryToJSON(value.country),
        'shopifyProductId': value.shopifyProductId,
        'id': value.id,
        'currentPosition': CoordinatesToJSON(value.currentPosition),
    };
}
